import { Project } from '../Portfolio';

const designProjects: Project[] = [
  {
    id: 'followup-design',
    title: 'portfolio.design.followup-design.title',
    description: 'portfolio.design.followup-design.description',
    technologies: [
      'Illustrator',
      'Logo',
      'Logotype',
      'Business Cards'
    ],
    picturesUris: [
      'https://i.imgur.com/nZ9SBMp.png',
      'https://i.imgur.com/uSGqsGG.png',
      'https://i.imgur.com/vtO7sJN.png'
    ]
  }
]

export default designProjects;